<template>
  <div>
    <slot :data="{ dialogIsVisible }"> </slot>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'DialogComponent',
  components: {},
  props: {
    init: {
      type: Function,
      default: (show, hide, isVisible) => {},
    },
    onPrimaryClick: {
      type: Function,
      default: () => {},
    },
    onOverlayClick: {
      type: Function,
      default: null,
    },
    onCancelClick: {
      type: Function,
      default: null,
    },
    onBackButtonClick: {
      type: Function,
      default: null,
    },
    iconLeftBg: {
      type: String,
      default: 'red',
    },
    overlayerCanDismiss: {
      type: Boolean,
      default: true,
    },
    buttonsToRight: {
      type: Boolean,
      default: true,
    },
    primaryButtonLoading: {
      type: Boolean,
      default: false,
    },
    hashBase: {
      type: String,
      default: 'dialog',
    },
  },
  data() {
    return {
      dialogIsVisible: false,
      hash: '',
      hiding: false,
    }
  },
  beforeUnmount() {
    if (!this.hashIsVisible()) return
    const newHash = this.$route.hash.replace(`${this.hash}`, '')
    this.$router.replace({ hash: newHash })
  },
  mounted() {
    this.hash = this.randHash()
  },
  methods: {
    randHash() {
      return `#${this.hashBase}-${this.$Commons.generateUUID()}`
    },
    show() {
      this.showModal()
    },
    hide() {
      if (this.hiding) return
      this.closeModal()
    },
    isVisible() {
      return this.dialogIsVisible
    },
    showModal() {
      this.pushNewHash()
      this.onOpening()
      this.dialogIsVisible = true
      this.onOpened()
    },
    async closeModal() {
      this.hiding = true
      this.onClosing()
      this.dialogIsVisible = false
      this.onClosed()
      if (this.hashIsVisible()) await this.backClircle()
      setTimeout(() => {
        this.hiding = false
      }, 100)
    },
    async backClircle() {
      this.$router.back()
      if (!this.hashIsVisible()) return
      await new Promise(r => setTimeout(r, 300))
      if (!this.hashIsVisible()) return
      return this.backClircle()
    },
    pushNewHash() {
      if (this.hashIsVisible()) return
      const newHash = `${this.$route.hash}${this.hash}`
      this.$router.push({ hash: newHash }).catch(e => {})
    },
    hashIsVisible(route = this.$route) {
      const hashRegex = new RegExp(this.hash)
      return hashRegex.test(route.hash)
    },
    onClosed() {
      this.$emit('closed')
    },
    onClosing() {
      this.$emit('closing')
    },
    onOpened() {
      this.$emit('opened')
    },
    onOpening() {
      this.$emit('opening')
    },
  },
  computed: {},
  watch: {
    $route: {
      deep: true,
      handler(newRoute) {
        if (!this.isVisible()) {
          if (!this.hashIsVisible(newRoute)) return
          this.showModal()
          return
        }
        if (this.hashIsVisible(newRoute)) return
        else this.closeModal()
      },
    },
  },
})
</script>
